// PageSchedule Component

import React from 'react'
import async from 'async'

import app from '../../../app.jsx'
import PageBase from '../page_base/page_base.jsx'
import ScheduleList from '../../user/schedule_list/schedule_list.jsx'
import ScheduleOptionUtil from '../../../lib/scheduleoptionutil.jsx'
import DialogSchedule from '../../dialog/dialog_schedule/dialog_schedule.jsx'
import DialogSetting from '../../../contact/dialog/dialog_setting/dialog_setting.jsx'
import ConfirmDelete from '../../../common/common/confirm_delete/confirm_delete.jsx'
import Button from '../../../common/common/button/button.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import IntlUtil from '../../../lib/intlutil.jsx'
import PageHeader from '../../../theme/layout/page_header/page_header.jsx'
import Acl from '../../../lib/acl.jsx'
import { ProfileIcon } from '../../../common/layout/menu_icons/profile.jsx'

class PageSchedule extends PageBase {
  constructor (props) {
    super(props, 'user-schedule', 'user-profile', 'user-schedule')

    this.state = {
      dataDate: null
    }

    this.data = {
      scheduleOptions: [],
      scheduleOption: null
    }

    this._references = {
      refDialogSchedule: React.createRef(),
      scheduleSettingDialog: React.createRef(),
      confirmDelete: React.createRef()
    }
  }

  componentDidMount () {
    this._getData()
  }

  renderContent () {
    const scheduleOptions = this.data.scheduleOptions

    return (
      <div className='page-schedule'>
        <ScheduleList
          scheduleOptions={scheduleOptions}
          onAddSchedule={this._onAddSchedule.bind(this)}
          onClickSetting={this._onClickSetting.bind(this)}
        />
        {this._renderSettingsDialog()}
        <DialogSchedule
          ref={this._references.refDialogSchedule}
          defaultSchedule={ScheduleOptionUtil.getDefaultScheduleOption()}
          onCreate={this._onCreateSchedule.bind(this)}
          onEdit={this._onEditSchedule.bind(this)}
        />
      </div>
    )
  }

  _onCreateSchedule (createData) {
    ScheduleOptionUtil.createSchedule(createData, err => {
      if (err) {
        app.debug('PageSchedule: _onCreateSchedule Error', err)
      } else {
        if (this._references.refDialogSchedule.current) {
          this._references.refDialogSchedule.current.hide()
        }
        this._reloadData()
      }
    })
  }

  _onEditSchedule (scheduleId, updateData) {
    ScheduleOptionUtil.updateSchedule(scheduleId, updateData, err => {
      if (err) {
        app.debug('PageSchedule: _onEditSchedule Error', err)
      } else {
        if (this._references.refDialogSchedule.current) {
          this._references.refDialogSchedule.current.hide()
        }
        this._reloadData()
      }
    })
  }

  _onClickSetting (scheduleOption) {
    this.data.scheduleOption = scheduleOption
    let totalHours = 0
    if (scheduleOption.schedules && scheduleOption.schedules.length > 0) {
      scheduleOption.schedules.forEach(item => {
        totalHours += item.timeTaken || 0
      })

      totalHours = parseFloat(totalHours / 2 / 60)
    }

    const fromDate = scheduleOption.fromDate
      ? this._convertSettingDisplayDate(scheduleOption.fromDate)
      : null
    const expireMsg = scheduleOption.toDate
      ? `${IntlUtil.convertMessage(
          'user.schedule.itemExpiresOn'
        )} ${this._convertSettingDisplayDate(scheduleOption.toDate)}`
      : null
    if (this._references.scheduleSettingDialog.current) {
      this._references.scheduleSettingDialog.current.show(
        fromDate,
        expireMsg,
        null,
        totalHours
      )
    }
    this.setState({ dataDate: new Date() })
  }

  _convertSettingDisplayDate (convertDate) {
    const date = convertDate ? new Date(convertDate) : null

    if (date) {
      const shortMonth = [
        'planner.planner.monthJanuary',
        'planner.planner.monthFebruary',
        'planner.planner.monthMarch',
        'planner.planner.monthApril',
        'planner.planner.monthMay',
        'planner.planner.monthJune',
        'planner.planner.monthJuly',
        'planner.planner.monthAugust',
        'planner.planner.monthSeptember',
        'planner.planner.monthOctober',
        'planner.planner.monthNovember',
        'planner.planner.monthDecember'
      ]

      const monthLabel = shortMonth[date.getMonth()]
        ? IntlUtil.convertMessage(shortMonth[date.getMonth()])
        : ''

      return `${date.getDate()} ${monthLabel} ${date.getFullYear()}`
    }

    return ''
  }

  _renderSettingsDialog () {
    const scheduleOption = this.data.scheduleOption

    return (
      <DialogSetting
        ref={this._references.scheduleSettingDialog}
        onClose={this._onCloseSetting.bind(this)}
        className='alt'
      >
        <div className='actionboard-row act-row'>
          <div className='actionboard-col2 alert-col2'>
            <div
              className='action-btn'
              onClick={this._onEdit.bind(this, scheduleOption)}
            >
              <Button
                icon='action-edit'
                className='button_dialog'
                canHover={false}
              />
              <span className='label'>
                <IntlMessage ident='estimate.view.editText' />
              </span>
            </div>
          </div>
          <div className='actionboard-col2 alert-col2'>
            <div className='action-btn' onClick={this._onDelete.bind(this)}>
              <Button
                icon='action-delete'
                className='button_dialog button_dialogdlt'
                canHover={false}
              />
              <span className='label'>
                <IntlMessage ident='estimate.view.deleteText' />
              </span>
            </div>
          </div>
        </div>
        <ConfirmDelete
          ref={this._references.confirmDelete}
          title='estimate.view.confirmTitle'
          onClickOk={this._onClickDeleteConfirm.bind(this)}
        />
      </DialogSetting>
    )
  }

  _onCloseSetting () {
    if (this._references.confirmDelete.current) {
      this._references.confirmDelete.current.hide()
    }
  }

  _onEdit (scheduleOption, e) {
    e.preventDefault()
    if (this._references.scheduleSettingDialog.current) {
      this._references.scheduleSettingDialog.current.hide()
    }

    if (scheduleOption && scheduleOption.id) {
      const schedule = ScheduleOptionUtil.getRenderScheduleObject(
        scheduleOption
      )
      const previousSchedulePeriods = ScheduleOptionUtil.getAllSchedulePeriods(
        this.data.scheduleOptions,
        schedule.id
      )
      if (this._references.refDialogSchedule.current) {
        this._references.refDialogSchedule.current.show(
          false,
          schedule,
          previousSchedulePeriods
        )
      }
    }
  }

  _onDelete (e) {
    e.preventDefault()
    this.data.pageNo = 1
    if (this._references.confirmDelete.current) {
      this._references.confirmDelete.current.show()
    }
  }

  _onClickDeleteConfirm (e) {
    e.preventDefault()

    if (!this.data.scheduleOption.id) {
      return false
    }

    ScheduleOptionUtil.removeSchedule(this.data.scheduleOption.id, err => {
      if (err) {
        app.debug('PageSchedule: _onClickDeleteConfirm Error', err)
      } else {
        if (this._references.scheduleSettingDialog.current) {
          this._references.scheduleSettingDialog.current.hide()
        }
        this._reloadData()
      }
    })
  }

  _onAddSchedule () {
    let scheduleWithoutToDate = null
    this.data.scheduleOptions.forEach(scheduleOpt => {
      if (!scheduleOpt.toDate) {
        scheduleWithoutToDate = scheduleOpt
      }
    })

    if (scheduleWithoutToDate) {
      const previousSchedulePeriods = ScheduleOptionUtil.getAllSchedulePeriods(
        this.data.scheduleOptions,
        scheduleWithoutToDate.id
      )
      const schedule = ScheduleOptionUtil.getRenderScheduleObject(
        scheduleWithoutToDate
      )
      if (this._references.refDialogSchedule.current) {
        this._references.refDialogSchedule.current.showForEndDate(
          schedule,
          previousSchedulePeriods
        )
      }
    } else {
      const previousSchedulePeriods = ScheduleOptionUtil.getAllSchedulePeriods(
        this.data.scheduleOptions,
        null
      )
      if (this._references.refDialogSchedule.current) {
        this._references.refDialogSchedule.current.show(
          true,
          null,
          previousSchedulePeriods
        )
      }
    }
  }

  /* renderHeader() {
    return (
      <PageHeaderUser title="user.profile.title" pageIdent="user-schedule"
        onChangePage={this._onChangePage.bind(this)} />
    );
  } */

  getContentClassname () {
    return 'alt'
  }

  /* Private Functions */
  _getData () {
    async.series(
      [
        done => {
          this._getPageData(done)
        },
        done => {
          this.data.scheduleOptions = []
          ScheduleOptionUtil.getUserScheduleOptions(
            app.loggedInId,
            (err, res) => {
              if (!err) {
                this.data.scheduleOptions = res
              }

              done(err)
            }
          )
        }
      ],
      (err, _res) => {
        this._onDataReceived(err)
      }
    )
  }

  _reloadData () {
    this._getData()
  }

  _onDataReceived (err) {
    if (err) {
      app.debug('PageSchedule: _onDataReceived ERROR', err)
      this._refresh()
    } else {
      app.debug('PageSchedule: _onDataReceived [done]')
      this._refresh()
    }
  }

  _refresh () {
    this.setState({ dataDate: new Date() })
  }

  /* Header Functions - START */
  renderHeader () {
    const tabsUser = [
      {
        ident: 'user-profile',
        title: 'user.overview.overview',
        showFavourite: true
      },
      {
        ident: 'user-schedule',
        title: 'user.schedule.schedule',
        showFavourite: true
      },
      {
        ident: 'user-skills',
        title: 'user.skills.skills',
        showFavourite: true
      },
      {
        ident: 'personal-setting',
        title: 'user.personal.settings',
        showFavourite: true
      }
    ]

    const tabs = []

    tabsUser.map((tabitem, _idx) => {
      if (Acl.isPageAllowed(tabitem.ident)) {
        tabs.push(tabitem)
      }
    })

    return (
      <PageHeader
        title='user.profile.title'
        icon={<ProfileIcon width={20} />}
        activeTab='user-schedule'
        favoriteTab={this._getUserFavoriteTab('user') || 'user-profile'}
        tabs={tabs}
        onTabChange={this._onHeaderTabChange.bind(this)}
        onToggleFavorite={this._onHeaderToggleFavorite.bind(this)}
      />
    )
  }

  _onHeaderTabChange (tab) {
    app.changePage(tab.ident)
  }

  _onHeaderToggleFavorite (tab) {
    this._updateUserStateFavorite('user', tab.ident)
    this.setState({ dataDate: new Date() })
  }

  /* Header Functions -END */
}

export default PageSchedule
